import {IPlatforms} from './IPlatforms';
import {PlatformDummy} from './PlatformDummy';
import {PlatformGan} from './PlatformGan';
import {PlatformGel} from './PlatformGel';
import {PlatformIforium} from './PlatformIforium';
import {PlatformEveryMatrix} from './PlatformEveryMatrix';
import {PlatformRelax} from './PlatformRelax';
import {PlatformRelaxFEIM} from './PlatformRelaxFEIM';
import {PlatformPariplay} from './PlatformPariplay';
import {PlatformSynotAPI} from './PlatformSynotAPI';
import {PlatformPlaytech} from './PlatformPlaytech';
import {Platforms} from './Platforms';

export {
    IPlatforms,
    PlatformDummy,
    PlatformGan,
    PlatformGel,
    PlatformIforium,
    PlatformEveryMatrix,
    PlatformRelax,
    PlatformRelaxFEIM,
    PlatformPariplay,
    PlatformSynotAPI,
    PlatformPlaytech,
    Platforms
};



/** WEBPACK FOOTER **
 ** ./Engine/Platforms/index.ts
 **/